import { FormsLibraryAssets } from './types/forms-library.types';

import sampleIcon from './assets/sample-icon.svg';
import visualIcon from './assets/Visual - Change This.svg';
import formIcon from './assets/Icon Token.svg';
import leftArrowDisabledIcon from './assets/left-arrow-disabled-icon.svg';
import leftArrowIcon from './assets/left-arrow-icon.svg';
import rightArrowIcon from './assets/right-arrow-icon.svg';
import successIcon from './assets/success.svg';
import crossIcon from './assets/cross-icon.svg';
import attentionIcon from './assets/attention-icon.svg';
import attachmentIcon from './assets/attachment.svg';
import leftArrowBlackIcon from './assets/Left Arrow Black.svg';
import addIcon from './assets/add_circle.svg';
import fraudIcon from './assets/Fraud-icon.svg';
import checkIcon from './assets/check.svg';
import noFormAvailableIcon from './assets/noForm-Icon.svg';
import calendarIcon from './assets/calendar.svg';
import imageIcon from './assets/img-icon.svg';
import pdfIcon from './assets/pdf-icon.svg';
import docIcon from './assets/doc-icon.svg';

export const FORMS_LIBRARY_ASSETS: FormsLibraryAssets = {
  SAMPLE_ICON: sampleIcon,
  FORM_ICON: formIcon,
  LEFT_ARROW_DISABLED_ICON: leftArrowDisabledIcon,
  LEFT_ARROW_ICON: leftArrowIcon,
  RIGHT_ARROW_ICON: rightArrowIcon,
  LEFT_ARROW_BLACK_ICON: leftArrowBlackIcon,
  SUCCESS_ICON: successIcon,
  CLOSE_ICON: crossIcon,
  VISUAL_ICON: visualIcon,
  ATTENTION_ICON: attentionIcon,
  ATTACHMENT_ICON: attachmentIcon,
  ADD_ICON: addIcon,
  FRAUD_ICON: fraudIcon,
  CHECK_ICON: checkIcon,
  NO_FORM_AVAILABLE: noFormAvailableIcon,
  CALENDAR_ICON: calendarIcon,
  IMAGE_ICON: imageIcon,
  PDF_ICON: pdfIcon,
  DOC_ICON: docIcon,
};
